module.exports = __webpack_public_path__ + "img/opentencent.543cb6b8.png";